import OpportunityForm from '@/features/opportunities/form/OpportunityForm.tsx';
import { useGetMe } from '@/lib/api/me.ts';

const NewOpportunityPage = () => {
  const { data: userData } = useGetMe();
  if (!userData) {
    return null;
  }
  return <OpportunityForm mode={'create'} />;
};

export default NewOpportunityPage;
